import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Error = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleGoBack = () => {
    navigate("/");
  };

  return (
    <div className="relative place-items-center h-full mx-4">
      <div className="mx-auto text-retta-dark-green mt-16 text-xl text-center bg-retta-beige rounded px-12 py-10">
        <p>{t("you-appear-no-access")}</p>
        <p className="pt-8">{t("please-contact")}</p>
      </div>
      <button
        onClick={handleGoBack}
        className="mx-auto text-retta-green mt-16 text-lg text-center w-full hover:underline"
      >
        {t("go-back")}
      </button>
    </div>
  );
};

export default Error;
